/**
 * payOneInit
 * @param cardType
 * @returns {Payone.ClientApi.HostedIFrames}
 */
window.payOneInit = function (cardType) {
    let config = {
        fields: {
            cardpan: {
                // put name of your div-container here
                selector: 'cardpanWrap',
                // text (default), password, tel
                type: 'text',
                style: ''
            },
            cardcvc2: {
                // put name of your div-container here
                selector: 'cardCVCWrap',
                // select(default), text, password, tel
                type: 'password',
                style: '',
                size: '4',
                maxlength: '4'
            },
            cardexpiremonth: {
                // put name of your div-container here
                selector: 'monthWrap',
                // select(default), text, password, tel
                type: 'select',
                size: '2',
                maxlength: '2',
                iframe: {}
            },
            cardexpireyear: {
                // put name of your div-container here
                selector: 'yearWrap',
                // select(default), text, password, tel
                type: 'select',
                iframe: {}
            }
        },
        defaultStyle: {
            input: 'width: 100%;height: 100%;background-color:transparent;display: block;padding: 0;border: none;outline: none;-webkit-box-shadow: none;-moz-box-shadow: none;box-shadow: none;-webkit-transition: all 300ms ease;-moz-transition: all 300ms ease;-ms-transition: all 300ms ease;-o-transition: all 300ms ease;transition: all 300ms ease;border-radius: 0;font-size: 1em;',
            select: 'width: 100%;height: 100%;background-color:transparent;display: block;padding: 0;border: none;outline: none;-webkit-box-shadow: none;-moz-box-shadow: none;box-shadow: none;-webkit-transition: all 300ms ease;-moz-transition: all 300ms ease;-ms-transition: all 300ms ease;-o-transition: all 300ms ease;transition: all 300ms ease;border-radius: 0;font-size: 1em;',
            iframe: {
                height: '100%',
                width: '100%'
            }
        },
        // area to display error-messages (optional)
        error: 'errorOutput',
        // Language to display error-messages, (default: Payone.ClientApi.Language.en)
        language: Payone.ClientApi.Language.de
    };

    // Ajax auf nicht async stellen, damit wir die Request-Daten weiter verabeiten können
    $.ajaxSetup({
        async: false
    });

    let request = {};
    $.getJSON(MP_PATH + 'ajax/helper/ajax.initPay.php', function (data) {
        const jsonData = JSON.parse(window.atob(data));

        request = {
            request: 'creditcardcheck',
            responsetype: 'JSON',
            mode: jsonData.mode,
            // your MID
            mid: jsonData.mID,
            // your AID
            aid: jsonData.aID,
            // your PortalId
            portalid: jsonData.portalID,
            // desired encoding
            encoding: 'UTF-8',
            // fixed value
            storecarddata: 'yes',
            hash: jsonData.hash
        };
    });

    // async wieder auf true
    $.ajaxSetup({
        async: true
    });

    let iframes;
    if ($('#cardType').length > 0) {
        iframes = new Payone.ClientApi.HostedIFrames(config, request);
        iframes.setCardType(cardType);

        document.getElementById('cardType').onchange = function () {
            // on change: set new type of credit card to process
            iframes.setCardType(this.value);
        };
    }

    return iframes;
};